import {
  Component,
  forwardRef,
  input,
  output,
  ChangeDetectionStrategy
} from '@angular/core';

import {
  FormArray,
  FormGroup,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule
} from '@angular/forms';
import {
  SelfDisclosureQuestion,
  SelfDisclosureQuestionType
} from '@ui/shared/model';

import { TranslatePipe } from '@ngx-translate/core';
import { SvgIconComponent } from 'angular-svg-icon';

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { ImmomioFormFieldComponent } from '@immomio/ui/form';
import { BaseControl } from '../../../components/legacy/form/controls/base-control';
import { FormFieldLabelComponent } from '../../../components/legacy/form/form-field/form-field-label/form-field-label.component';
import { FormFieldComponent } from '../../../components/legacy/form/form-field/form-field.component';
import { AppInputDirective } from '../../../components/legacy/form/controls/input/input.directive';
import { DateComponent } from '../../../components/legacy/form/controls/date/date.component';

@Component({
  selector: 'app-self-disclosure-child',
  templateUrl: './self-disclosure-child.component.html',
  styleUrls: ['./self-disclosure-child.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelfDisclosureChildComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    SvgIconComponent,
    TranslatePipe,
    FormFieldLabelComponent,
    FormFieldComponent,
    AppInputDirective,
    DateComponent,
    ImmomioFormFieldComponent
  ]
})
export class SelfDisclosureChildComponent extends BaseControl<any> {
  readonly selfDisclosureQuestion = input<SelfDisclosureQuestion>(undefined);
  readonly title = input<string, string>(undefined, {
    transform: v => v || this.selfDisclosureQuestion().title
  });
  readonly form = input<FormGroup>(undefined);
  readonly showRemove = input(false);
  readonly showBirthdate = input(true);

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  readonly onRemove = output<void>();

  public maxDateStruct: NgbDateStruct = {
    year: moment().year(),
    month: moment().month() + 1,
    day: moment().date()
  };

  public startDateStruct: NgbDateStruct = {
    year: 1990,
    month: 1,
    day: 1
  };

  public minDateStruct: NgbDateStruct = {
    year: 1900,
    month: 1,
    day: 1
  };

  public writeValue(value: any) {
    this.value = value ? value : [];
  }

  public get getAnswerFormControl() {
    return this.form().get('answer') as FormGroup;
  }

  public get getSubQuestionsFormArray(): FormArray | null {
    return (this.form()?.get('subQuestions') as FormArray) || null;
  }

  public isBirthYearSubQuestion(subQuestion: SelfDisclosureQuestion) {
    return (
      !!subQuestion?.showSelfDisclosureQuestions &&
      subQuestion?.type === SelfDisclosureQuestionType.BIRTH_YEAR &&
      subQuestion?.title === 'SELF_DISCLOSURE_CHILDREN_BIRTH_YEAR'
    );
  }

  public removeHandler() {
    this.onRemove.emit();
  }
}
